import { UUID } from 'angular2-uuid';
import { ICheckTax } from 'src/app/common/tax/models/tax-order.model';
import { FiscalCheck } from 'src/app/models/fiscal-check';
import DateUtils from 'src/app/utility/date-utils';
import MoneyUtils from 'src/app/utility/money-utils';
import { ICustomer } from './repositories/customers.repository';
import { IPromo } from 'src/app/models/promo';

export interface IOrder {}

export interface IReceipt {
  id: number;
  uuid: string;
  companyId: string;
  deviceId: string;
  storeId: number;
  amountdiscount: number;
  percentdiscount: number;
  percentDiscount: number;
  hasWorkAreas: boolean;
  discount: number;
  sourceSum: number;
  cashbackAmount: number;
  amount: number;
  bonusesAmount?: number;

  cashbackAccrued: number;
  cashbackDeducted: number;
  moneyPayment: number;
  coinsAccrued: number;
  coinsDeducted: number;
  coinsBalance: number;
  promoDataJson: string;
  displayDiscount?: boolean;

  providedSum?: number;
  remainsSum?: number;
  total: number;
  created?: string;
  createdby?: string;
  createdName?: string;
  deleted?: string;
  employee?: string;
  customer?: ICustomer;
  customer_id?: number;
  customerphone?: string;
  employee_name?: string;
  payment_status?: string;
  returntotal?: number;
  storename?: string;
  iscashless: boolean;
  date_open: string;
  opened?: string;
  openedby?: string;
  openedName?: string;

  note: string;
  publicNote: string;
  date_close: string;
  total_str?: string;

  store_name?: string;
  storeName?: string;
  payment_type?: string;

  products: IReceiptProduct[];
  salesReceiptProducts: IReceiptProduct[];
  returnOrders: IReceipt[];
  wish?: string;
  terminalsessionid?: string;
  fiscalnumber?: string;
  fiscalNumber?: string;
  taxRegisterFiscalNumber?: string;
  taxregisterfiscalnumber?: string;
  isFiscal?: boolean;
  saleorderid?: number;
  loyaltyprogramname?: string;
  promoName?: string;
  loyalty_program_id?: number;
  loyaltyProgramId?: number;
  promoId?: number;
  paymentTypeId?: number;
  paymentType: 'card' | 'cash' | 'bonuses';
  paymentMethod?: any;
  discountRemoved?: boolean;
  xmlCheck?: string;
  taxes?: ICheckTax[];
  exciseLabelsScan: boolean;
  companyName?: string;
  companyFiscalNumber?: string;
  cashier?: string;
  pointName?: string;
  pointAddress?: string;
  taxRegisterName?: string;
  rndSum?: number;
  noRndSum?: number;
  partnerId?: number;
  tipsAmount?: number;
  tipsAmountView?: string;
  servicePercent?: number;
  serviceAmount?: number;
  serviceAmountView?: string;
  serviceStoreId?: number;
  delivery?: any;
  deliveryId?: string;
  deliveryAddress?: string;
  coinsBack: number;
  testing?: boolean;
  online?: boolean;
  taxOrderDate?: string;
  taxOrderTime?: string;
  taxOrderNumber?: number;
  orderNumber?: string;
  subDocType?: number;
  saleOrderId?: number;
  isPaid?: boolean;
  payments?: any[];
  fiscalChecks?: FiscalCheck[];
  documentDate: string;
  totalAmount: number;
  invoices?: any[];
  offline: boolean;
  updated?: string;
  table?: any;
  appVersion?: number;
  totalReturned?: number;
  useDefaultTax?: boolean;
  defaultTaxLetter?: string;
  rroXmlReceipt?: string;
  promoNext: boolean;
}

export interface IReceiptProduct {
  productid: number;
  productId?: number;
  storeId?: number;
  name: string;
  productName?: string;
  amount?: number;
  amount_formatted?: string;
  amount_str?: string;
  barcode?: string;
  returnedquantity?: number;
  price: number;
  price_str?: string;
  netprice?: number;
  cost?: number;
  price_formatted?: string;
  quantity: number;
  quantity_formatted?: string;
  weighted?: boolean;
  chips_for_issue?: number;
  chips_cost?: number;
  productTypeId: number;
  unitId?: number;
  unit?: string;
  work_area_id?: number;
  uuid?: string;
  work_start?: string;
  closed?: string;
  productType?: string;
  percentDiscount?: number;
  amountDiscount?: number;
  discount?: number;
  cashback?: number;
  cashbackSum?: string;
  discountSum?: number;
  displayDiscount?: boolean;
  totalAmount?: number;
  totalPrice?: number;
  total_str?: string;
  providedAmount?: number;
  remainsAmount?: number;
  discountType?: 0 | 1;
  producttaxid?: number;
  producttaxname?: string;
  producttaxpercent?: number | null;
  producttaxletter?: string;

  taxId?: number;
  taxName?: string;
  taxPercent?: number;
  taxLetter?: string;

  taxprice?: number;

  excisetaxid?: number;
  excisetaxname?: string;
  excisetaxpercent?: number;
  excisetaxletter?: string;
  excisemarkrequired?: boolean;

  exciseTaxId?: number;
  exciseTaxName?: string;
  exciseTaxPercent?: number;
  exciseTaxLetter?: string;

  exciseLabels?: string[];
  uktzedcode?: string;
  uktZedCode?: string;
  coinsPrice?: number;
  coinsBack?: number;
  returnQuantity?: number;
  manualInput?: boolean;
  categoryId?: number;
  category?: string;
  customerAssetId?: number;
  customerAssetDescription?: string;
}

export interface IReturnReceipt {
  id: number;
  salesreceiptid: number;
  created: Date;
  createdby: string;
  employee_name?: string;
  payment_status?: string;
  products: IReturnProduct[];
}

export interface IReturnProduct {
  name: string;
  quantity: number;
  amount: number;
}

export class Receipt implements IReceipt {
  id = 0;
  uuid: string;
  companyId: string;
  deviceId: string;
  storeId: number;
  storeName: string;
  amountdiscount: number;
  percentdiscount: number;
  percentDiscount: number;
  percentCashback: number;

  hasWorkAreas: boolean;
  discount = 0;
  displayDiscount = false;
  sourceSum = 0;
  cashbackAmount = 0;
  amount: number;
  bonusesAmount?: number;

  cashbackAccrued = 0;
  cashbackDeducted = 0;
  moneyPayment = 0;
  coinsAccrued = 0;
  coinsDeducted = 0;
  coinsBalance = 0;
  promoDataJson: string;

  providedSum?: number;
  remainsSum?: number;
  total: number;
  total_str: string;
  note: string;
  publicNote: string;
  iscashless = false;

  products: IReceiptProduct[] = [];
  salesReceiptProducts: IReceiptProduct[];
  returnOrders: IReceipt[];
  date_open: string;
  opened: string;
  openedby: string;
  openedBy: string;
  openedName?: string;
  date_close: string;
  employee?: string;
  customer?: any;
  customer_id?: number;
  customerphone?: string;
  employee_name?: string;
  payment_status?: string;
  created: string;

  store_name: string;
  payment_type?: string;
  paymentTypeId?: number;
  paymentType: 'card' | 'cash' | 'bonuses';
  paymentMethod?: any;
  wish?: string;
  chipsTotal: number;
  fiscalnumber?: string;
  taxregisterfiscalnumber?: string;
  isFiscal?: boolean;
  loyaltyProgramId?: number;
  loyalty_program_id?: number;
  promoId?: number;
  promoName?: string;

  discountRemoved?: boolean;
  rndSum?: number;
  noRndSum?: number;
  tipsAmount?: number;
  tipsAmountView?: string;
  servicePercent = 0;
  serviceAmount = 0;
  serviceAmountView?: string;
  serviceStoreId?: number;
  delivery?: any;
  coinsBack: number;
  totalAmount: number;
  table?: any;
  appVersion?: number;
  promoNext: boolean;

  get deliveryAddress(): string {
    if (!this.delivery) {
      return '';
    }

    return `${this.delivery.street} ${this.delivery.houseNumber}`;
  }

  private _productsDiscounts: { [key: number]: number } = {};
  private _productsCashbacks: { [key: number]: number } = {};
  private _categoryDiscounts: { [key: number]: number } = {};
  private _itemDiscounts: { [key: string]: number } = {};

  taxes: ICheckTax[];
  get exciseLabelsScan(): boolean {
    const _exciseProducts = this.getExciseLabelsProducts();
    return _exciseProducts && _exciseProducts.length > 0;
  }

  constructor(receipt?: IReceipt) {
    this.promoNext = true;
    if (!receipt) {
      this.uuid = UUID.UUID();
      this.opened = DateUtils.format();
      this.date_open = DateUtils.format();

      this.orderNumber = this._getOrderNumber();
      this.appVersion = 2; // for new weighted products logic
      return;
    }

    this.id = receipt.id;
    this.uuid = receipt.uuid;
    this.employee = receipt.employee;
    this.employee_name = receipt.employee_name;
    this.customer = receipt.customer;
    this.customer_id = receipt.customer_id;
    this.customerphone = receipt.customerphone;
    this.taxOrderNumber = receipt.taxOrderNumber;
    this.payment_status = receipt.payment_status;
    this.amountdiscount = receipt.amountdiscount;
    this.percentdiscount = receipt.percentdiscount;
    this.amount = receipt.amount;
    this.total_str = MoneyUtils.money(receipt.total);
    this.total = receipt.total;
    this.totalAmount = receipt.totalAmount;
    this.note = receipt.note;
    this.publicNote = receipt.publicNote;
    this.products = receipt.products || [];
    this.opened = receipt.opened;
    this.openedby = receipt.openedby;
    this.openedBy = receipt.openedby;
    this.openedName = receipt.openedName;
    this.date_open = receipt.date_open;
    this.date_close = receipt.date_close;
    this.created = receipt.created;
    this.iscashless = receipt.iscashless;
    this.fiscalnumber = receipt.fiscalnumber;
    this.taxregisterfiscalnumber = receipt.taxregisterfiscalnumber;
    this.isFiscal = receipt.isFiscal;
    this.loyaltyProgramId = receipt.loyaltyProgramId;
    this.loyalty_program_id = receipt.loyalty_program_id;
    this.promoName = receipt.loyaltyprogramname;
    this.promoId = receipt.loyaltyProgramId || receipt.loyalty_program_id;
    this.loyaltyprogramname = receipt.loyaltyprogramname;

    this.discountRemoved = receipt.discountRemoved;

    this.paymentTypeId = receipt.paymentTypeId;
    this.rndSum = receipt.rndSum;
    this.noRndSum = receipt.noRndSum;
    this.providedSum = receipt.providedSum;
    this.remainsSum = receipt.remainsSum;
    this.tipsAmount = receipt.tipsAmount;
    this.servicePercent = receipt.servicePercent || 0;
    this.serviceAmount = receipt.serviceAmount || 0;
    this.serviceStoreId = receipt.serviceStoreId;
    this.delivery = receipt.delivery;
    this.storeId = receipt.storeId;
    this.orderNumber = receipt.orderNumber;
    this.offline = receipt.offline;
    this.table = receipt.table;
    this.appVersion = receipt.appVersion;
    this.companyId = receipt.companyId;
    this.storeName = receipt.storeName || receipt.store_name;
    this.defaultTaxLetter = receipt.defaultTaxLetter;
    this.useDefaultTax = receipt.useDefaultTax;
    this.deliveryId = receipt.deliveryId;
    if (receipt.fiscalChecks) {
      this.fiscalChecks = receipt.fiscalChecks;
    }
    if (receipt.payments) {
      this.payments = receipt.payments;
    }

    this.cashbackAccrued = receipt.cashbackAccrued;
    this.cashbackDeducted = receipt.cashbackDeducted;
    this.bonusesAmount = receipt.bonusesAmount;
    this.moneyPayment = receipt.moneyPayment;
    this.coinsAccrued = receipt.coinsAccrued;
    this.coinsDeducted = receipt.coinsDeducted;
    this.coinsBalance = receipt.coinsBalance;
    this.promoDataJson = receipt.promoDataJson;

    this._itemDiscounts = {};
    for (const product of this.products) {
      this.rememberOwnItemDiscount(product, !!product.displayDiscount);
    }

    this.calculate();
  }
  fiscalNumber?: string;
  taxRegisterFiscalNumber?: string;
  saleorderid?: number;
  loyaltyprogramname?: string;
  xmlCheck?: string;
  companyName?: string;
  companyFiscalNumber?: string;
  cashier?: string;
  pointName?: string;
  pointAddress?: string;
  taxRegisterName?: string;
  partnerId?: number;
  testing?: boolean;
  offline: boolean;
  taxOrderDate?: string;
  taxOrderTime?: string;
  taxOrderNumber?: number;
  orderNumber?: string;
  subDocType?: number;
  saleOrderId?: number;
  invoices?: any[];
  invoiceOrderId?: number;
  isPaid?: boolean;
  payments?: any[];
  fiscalChecks?: FiscalCheck[];
  documentDate: string;

  createdby?: string;
  deleted?: string;
  returntotal?: number;
  storename?: string;
  terminalsessionid?: string;
  useDefaultTax?: boolean;
  defaultTaxLetter?: string;
  deliveryId?: string;

  private _getOrderNumber(): string {
    const _now = new Date();
    const _year = _now.getFullYear();
    const _month = _now.getMonth();
    const leters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const rundomNumber = this._getRundomString(8);
    const yearMonth = (_year + _month + 1).toString();
    const firstLeterIndex = yearMonth[yearMonth.length - 2];
    const secondLeterIndex = yearMonth[yearMonth.length - 1];

    return `${leters[firstLeterIndex]}${leters[secondLeterIndex]}${rundomNumber}`;
  }

  getExciseLabelsProducts(): any[] {
    if (!this.products || this.products.length == 0) {
      return [];
    }

    return this.products.filter((p) => p.excisemarkrequired);
  }

  static getPaidAmount(order: IReceipt): number {
    if (!order) {
      return 0;
    }

    const payments = order.payments || [];
    if (payments.length) {
      return MoneyUtils.round(
        payments.reduce((sum, payment) => sum + (+payment.amount || 0), 0),
      );
    }

    return MoneyUtils.round(
      (order.fiscalChecks || []).reduce(
        (sum, check) => sum + (+check.amount || 0),
        0,
      ),
    );
  }

  static getLeftToPay(order: IReceipt): number {
    if (!order) {
      return 0;
    }

    return MoneyUtils.round(
      Math.max(0, (order.total || 0) - Receipt.getPaidAmount(order)),
    );
  }

  static isPartiallyPaid(order: IReceipt): boolean {
    const paid = Receipt.getPaidAmount(order);
    return paid > 0 && Receipt.getLeftToPay(order) > 0;
  }

  static appendServiceToCheckBody(order: IReceipt, checkBody: any[]): void {
    if (!order || !(order.serviceAmount > 0) || !checkBody) {
      return;
    }

    checkBody.push({
      NAME: 'Обслуговування',
      CODE: 0,
      PRICE: order.serviceAmount,
      AMOUNT: 1,
      COST: order.serviceAmount,
      LETTERS: order.defaultTaxLetter || '',
    });
  }

  private _getRundomString(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  addCustomer(customer: ICustomer) {
    this.customer = customer;
    this.customer_id = customer.id;
    this.customerphone = customer.phone;
  }

  removeCustomer() {
    this.customer = null;
    this.customer_id = null;
    this.customerphone = null;
    this.selectLoyaltyProgram(null);
  }

  addTips(amount: number) {
    this.tipsAmount = amount;
    this.tipsAmountView = MoneyUtils.money(amount);
    this.calculate();
  }

  cancelTips() {
    this.tipsAmount = 0;
    this.tipsAmountView = '';
    this.calculate();
  }

  addServicePercent(percent: number) {
    const normalized = Math.min(Math.max(Number(percent) || 0, 0), 100);
    if (normalized <= 0) {
      this.cancelService();
      return;
    }

    this.servicePercent = normalized;
    this.ensureServiceStoreId();
    this.calculate();
  }

  cancelService() {
    this.servicePercent = 0;
    this.serviceAmount = 0;
    this.serviceAmountView = '';
    this.serviceStoreId = undefined;
    this.calculate();
  }

  attachServiceToStore(storeId: number) {
    this.serviceStoreId = storeId;
  }

  private ensureServiceStoreId() {
    if (this.serviceStoreId || !this.products?.length) {
      return;
    }

    const storeIds = Array.from(
      new Set(this.products.map((p) => p.storeId || this.storeId)),
    ).filter((id) => id != null);
    if (storeIds.length === 1) {
      this.serviceStoreId = storeIds[0];
    }
  }

  private updateProductsDiscounts(loyaltyProgram: IPromo) {
    this._productsDiscounts = {};
    this._productsCashbacks = {};
    this._categoryDiscounts = {};

    this.amountdiscount = 0;
    this.percentdiscount = 0;
    this.percentCashback = 0;
    for (let p of this.products) {
      p.percentDiscount = 0;
      p.amountDiscount = 0;
      p.cashback = 0;
    }

    if (!loyaltyProgram) {
      return;
    }

    this.percentdiscount = loyaltyProgram.percentageDiscount;
    this.percentCashback = loyaltyProgram.purchaseBonuses;

    if (loyaltyProgram.products && loyaltyProgram.products.length) {
      this._productsDiscounts = loyaltyProgram.products.reduce(
        (prevValue, currentValue) => {
          prevValue[currentValue.productId] =
            currentValue.percentDiscount || loyaltyProgram.percentageDiscount;
          return prevValue;
        },
        {},
      );

      this._productsCashbacks = loyaltyProgram.products.reduce(
        (prevValue, currentValue) => {
          prevValue[currentValue.productId] =
            currentValue.cashBackPercent || loyaltyProgram.purchaseBonuses;
          return prevValue;
        },
        {},
      );
    }

    if (loyaltyProgram.categories && loyaltyProgram.categories.length) {
      this._categoryDiscounts = loyaltyProgram.categories.reduce(
        (prevValue, currentValue) => {
          prevValue[currentValue.categoryId] =
            currentValue.percentDiscount || loyaltyProgram.percentageDiscount;
          return prevValue;
        },
        {},
      );
    }
  }

  selectLoyaltyProgram(loyaltyProgram?: IPromo) {
    this.updateProductsDiscounts(loyaltyProgram);

    if (loyaltyProgram) {
      this.loyaltyProgramId = loyaltyProgram.id;
      this.loyalty_program_id = loyaltyProgram.id;
      this.promoId = loyaltyProgram.id;
      this.promoName = loyaltyProgram.name;
      this.discountRemoved = false;
    } else {
      this.loyaltyProgramId = null;
      this.loyalty_program_id = null;
      this.promoId = null;
      this.promoName = null;
      this.discountRemoved = true;
    }

    this.calculate();
  }

  public increaseItemQuantity(itemId: string): void {
    const p = this.products.find(
      (v) => v.uuid.toLowerCase() == itemId.toLowerCase(),
    );
    if (!p) {
      return;
    }

    p.quantity += 1;
    this.calculate();
  }

  public decreaseItemQuantity(itemId: string): void {
    const p = this.products.find(
      (v) => v.uuid.toLowerCase() == itemId.toLowerCase(),
    );
    if (!p) {
      return;
    }

    if (p.quantity == 1) {
      this.removeOrderItem(itemId);
    } else {
      p.quantity -= 1;
      this.calculate();
    }
  }

  public addItem(product: IProduct, quantity: number, storeId?: number) {
    const orderProduct: IReceiptProduct = {
      productid: product.id,
      uuid: UUID.UUID(),
      name: product.name,
      cost: product.cost,
      price: +product.price,
      netprice: +product.netprice,
      quantity: quantity,
      weighted: product.weighted,
      chips_cost: product.chips_cost,
      chips_for_issue: product.chips_for_issue,
      productTypeId: product.product_type_id,
      unitId: product.unitid,
      unit: product.unit,
      work_area_id: product.work_area_id,
      producttaxid: product.producttaxid,
      producttaxname: product.producttaxname,
      producttaxpercent: product.producttaxpercent,
      producttaxletter: product.producttaxletter,

      excisetaxid: product.excisetaxid,
      excisetaxname: product.excisetaxname,
      excisetaxpercent: product.excisetaxpercent,
      excisetaxletter: product.excisetaxletter,
      uktzedcode: product.uktzedcode,
      coinsBack: product.coinsBack,
      coinsPrice: product.coinsPrice,
      categoryId: product.category_id,
      category: product.categoryname,
      excisemarkrequired: product.excisemarkrequired,
      returnedquantity: 0,
      amount: product.price,
    };

    if (storeId != null) {
      orderProduct.storeId = storeId;
    }

    this.products.push(orderProduct);
    this.calculate();
  }

  public addProduct(product: IReceiptProduct) {
    const p = this.products.find((v: IReceiptProduct) => {
      if (v.productid !== product.productid) {
        return false;
      }
      if (v.storeId == null && product.storeId == null) {
        return true;
      }
      return v.storeId === product.storeId;
    });
    if (!p) {
      const _p = product;
      _p.amount = product.price;
      _p.returnedquantity = 0;

      this.products.push(_p);
      this.rememberOwnItemDiscount(_p);

      // this.products.push({
      //   productid: product.productid,
      //   name: product.name,
      //   amount: product.price,
      //   price: product.price,
      //   quantity: product.quantity,
      //   returnedquantity: 0,
      //   weighted: product.weighted,
      //   chips_cost: product.chips_cost,
      //   chips_for_issue: product.chips_for_issue,
      //   productTypeId: product.productTypeId,
      //   unitId: product.unitId,
      //   work_area_id: product.work_area_id,
      // });
    } else {
      if (product.weighted || product.unitId == 1) {
        p.quantity = parseFloat(product.quantity.toString());
      } else {
        p.quantity =
          parseFloat(p.quantity.toString()) +
          parseFloat(product.quantity.toString());
      }
    }

    if (p && p.quantity === 0) this.removeProduct(p.productid);

    this.calculate();
  }

  updateQuantity(productId: number, quantity: number): void {
    let index;
    const p = this.products.find((v: IReceiptProduct, i: number) => {
      if (v.productid !== productId) return false;

      index = i;
      return true;
    });

    if (!p) {
      return;
    }

    p.quantity = quantity || 0;
    this.calculate();
  }

  updateItemQuantity(uuid: string, quantity: number): void {
    const p = this.products.find(
      (v: IReceiptProduct, i: number) => v.uuid == uuid,
    );

    if (!p) {
      return;
    }

    p.quantity = quantity || 0;
    this.calculate();
  }

  updatePrice(itemId: string, price: number): void {
    const p = this.products.find((v: IReceiptProduct) => v.uuid == itemId);

    if (!p) {
      return;
    }

    p.price = price || 0;
    this.calculate();
  }

  public removeProduct(productId: number) {
    let index;
    const p = this.products.find((v: IReceiptProduct, i: number) => {
      if (v.productid !== productId) return false;

      index = i;
      return true;
    });

    if (!p) return;
    else {
      if (p.weighted || p.unitId == 1 || p.unitId == 3) {
        p.quantity = 0;
      } else {
        p.quantity -= 1;
      }
      if (p.quantity === 0 || p.quantity < 0) {
        this.products.splice(index, 1);
      }
    }

    this.calculate();
  }

  public deleteProduct(productId: number) {
    let index;
    const p = this.products.find((v: IReceiptProduct, i: number) => {
      if (v.productid !== productId) return false;

      index = i;
      return true;
    });

    if (!p) return;
    else {
      this.products.splice(index, 1);
    }

    this.calculate();
  }

  public removeOrderItem(uuid: string) {
    let index;
    const p = this.products.find((v: IReceiptProduct, i: number) => {
      if (v.uuid !== uuid) return false;

      index = i;
      return true;
    });

    if (!p) return;
    else {
      this.products.splice(index, 1);
    }

    this.calculate();
  }

  public more(productId: number) {
    let index;
    const p = this.products.find((v: IReceiptProduct, i: number) => {
      if (v.productid !== productId) return false;

      index = i;
      return true;
    });

    if (!p) return;
    else p.quantity += 1;

    this.calculate();
  }

  public setDiscount(percentDiscount: number, amountDiscount: number) {
    if (percentDiscount >= 0) {
      this.percentdiscount = +percentDiscount;
    } else {
      this.percentdiscount = 0;
      for (let p of this.products) {
        p.percentDiscount = 0;
      }
    }

    if (amountDiscount >= 0) {
      this.amountdiscount = +amountDiscount;
    }

    this.calculate();
  }

  public setProductDiscount(
    itemId: string,
    percentDiscount: number,
  ): void {
    const product = this.products.find((item) => item.uuid === itemId);
    if (!product) {
      return;
    }

    const normalizedDiscount = Math.min(
      Math.max(Number(percentDiscount) || 0, 0),
      100,
    );
    if (normalizedDiscount > 0) {
      this._itemDiscounts[itemId] = normalizedDiscount;
    } else {
      delete this._itemDiscounts[itemId];
    }
    product.percentDiscount = normalizedDiscount;

    this.calculate();
  }

  public updateProvidedSum(providedSum: number) {
    if (this.amount <= providedSum) {
      this.providedSum = providedSum;

      this.remainsSum = providedSum - this.total;
    }
  }

  public updatePaymentType(paymentType: 'card' | 'cash' | 'bonuses') {
    // 0–Готівка, 1–Банківська картка, 2-Попередня оплата, 3-Кредит
    this.paymentType = paymentType;
    // TODO update paymentTypeId (legacy)
    switch (paymentType?.toLocaleLowerCase()) {
      case 'card':
        this.paymentTypeId = 0;
        this.iscashless = true;
        break;

      case 'cash':
        this.iscashless = false;
        this.paymentTypeId = 1;
        break;

      case 'bonuses':
        this.paymentTypeId = 2;
        break;

      default:
        this.paymentTypeId = undefined;
        this.iscashless = false;
    }

    this.calculate();
  }

  public updateProvidedBonuses(amount?: number) {
    this.bonusesAmount = amount;
    this.cashbackDeducted = amount;
    this.calculate();
  }

  public updatePaymentMethod(paymentMethod: any) {
    this.paymentMethod = paymentMethod;
  }

  updateExciseLabels(
    products: { productId: number; labels: string[] }[],
  ): void {
    for (let p of products) {
      const product = this.products.find((_) => _.productid == p.productId);
      product.exciseLabels = p.labels;
    }
  }

  private calculate() {
    let _chipsTotal = 0;
    let _amountDiscount = 0;
    this.amount = 0;
    this.discount = 0;
    this.taxes = [];
    this.rndSum = null;
    this.noRndSum = null;
    this.hasWorkAreas = false;
    this.coinsBack = 0;
    let _cashbackAmount = 0;

    // amount
    for (let product of this.products) {
      if (product.coinsBack > 0) {
        this.coinsBack += product.coinsBack * product.quantity;
      }

      if (product.work_area_id > 0) {
        this.hasWorkAreas = true;
      }

      product.amount = MoneyUtils.round(product.price * product.quantity);
      product.totalAmount = product.amount;
      product.amount_str = MoneyUtils.money(product.amount);
      product.price_str = MoneyUtils.money(product.price);
      this.amount += product.amount;

      // chips
      if (!this.promoId) {
        const chipsCost =
          (product.chips_cost - (product.chips_for_issue || 0)) *
          product.quantity;

        if (chipsCost) {
          _chipsTotal += MoneyUtils.round(chipsCost);
        }
      }

      product.displayDiscount = false;
      const itemDiscount = product.uuid
        ? this._itemDiscounts[product.uuid]
        : 0;
      const productDiscount = this._productsDiscounts[product.productid];
      const categoryDiscount = this._categoryDiscounts[product.categoryId];
      if (itemDiscount > 0) {
        product.percentDiscount = itemDiscount;
        product.displayDiscount = true;
      } else if (productDiscount > 0) {
        product.percentDiscount = productDiscount;
        product.displayDiscount = true;
      } else if (categoryDiscount > 0) {
        product.percentDiscount = categoryDiscount;
        product.displayDiscount = true;
      } else if (this.percentdiscount > 0) {
        product.percentDiscount = this.percentdiscount;
      } else {
        product.percentDiscount = 0;
      }

      if (!this.percentCashback) {
        product.cashback = this._productsCashbacks[product.productid];
      }

      if (product.cashback > 0) {
        const _cashback = MoneyUtils.round(
          (product.amount * product.cashback) / 100,
        );

        product.cashbackSum = _cashback.toFixed(2);
        _cashbackAmount += _cashback;
      }

      if (product.percentDiscount > 0) {
        product.percentDiscount = Math.min(product.percentDiscount, 100);
        product.discountType = 1;
        product.discountSum = MoneyUtils.round(
          (product.amount * product.percentDiscount) / 100,
        );

        product.amountDiscount =
          (product.amount * product.percentDiscount) / 100;
        product.discount = product.amountDiscount;
        product.totalAmount = MoneyUtils.round(
          product.amount - product.discountSum,
        );
        product.amountDiscount = MoneyUtils.round(
          product.amount - product.totalAmount,
        );
        _amountDiscount += product.amountDiscount;
        product.total_str = MoneyUtils.money(product.totalAmount);
      } else {
        product.total_str = MoneyUtils.money(product.amount);
        product.amountDiscount = 0;
        product.discountType = undefined;
        product.percentDiscount = 0;
        product.discountSum = 0;
        product.discount = 0;
      }

      // taxes
      this._addProductTax(product);
    }

    this.amount = MoneyUtils.round(this.amount);
    this.chipsTotal = _chipsTotal;
    this.discount = 0;
    this.displayDiscount = this.percentdiscount > 0;
    this.sourceSum = this.amount - this.cashbackDeducted;

    if (_amountDiscount > 0) {
      this.discount = _amountDiscount;
    } else if (this.amountdiscount > 0) {
      this.discount = Math.min(this.amountdiscount, this.amount);
    }

    this.cashbackAmount = _cashbackAmount;
    this.cashbackAccrued = _cashbackAmount;
    if (this.percentCashback > 0) {
      const _cashback = MoneyUtils.round(
        (this.sourceSum * this.percentCashback) / 100,
      );
      this.cashbackAmount = _cashback;
      this.cashbackAccrued = _cashback;
    }

    this.total = MoneyUtils.round(Math.max(0, this.amount - this.discount));

    if (this.bonusesAmount > 0) {
      this.total = this.total - this.bonusesAmount;
    }

    if (this.servicePercent > 0) {
      this.servicePercent = Math.min(this.servicePercent, 100);
      this.serviceAmount = MoneyUtils.round(
        (this.total * this.servicePercent) / 100,
      );
    } else {
      this.serviceAmount = +(this.serviceAmount || 0);
    }

    if (this.serviceAmount > 0) {
      this.total = MoneyUtils.round(this.total + this.serviceAmount);
      this.serviceAmountView = MoneyUtils.money(this.serviceAmount);
    } else {
      this.serviceAmount = 0;
      this.serviceAmountView = '';
    }

    this.totalAmount = this.total;

    if (this.tipsAmount > 0) {
      this.tipsAmountView = MoneyUtils.money(this.tipsAmount);
    }

    if (this.paymentType == 'cash') {
      this._roundTotal();
    } else {
      this.providedSum = null;
      this.remainsSum = null;
    }

    this.total_str = MoneyUtils.money(this.total);
    this._roundTaxes();
  }

  private rememberOwnItemDiscount(
    product: IReceiptProduct,
    force = false,
  ): void {
    if (!product?.uuid || !(product.percentDiscount > 0)) {
      return;
    }

    if (
      !force &&
      Number(product.percentDiscount) === Number(this.percentdiscount)
    ) {
      return;
    }

    this._itemDiscounts[product.uuid] = product.percentDiscount;
  }

  private _roundTaxes() {
    for (let tax of this.taxes) {
      tax.TURNOVER = MoneyUtils.round(tax.TURNOVER);
      tax.SOURCESUM = MoneyUtils.round(tax.SOURCESUM);
      tax.SUM = MoneyUtils.round(tax.SUM);
    }
  }

  private _roundTotal() {
    const amountInCents = this.total * 100;
    const centsRoundTo = 10;
    const restCents = MoneyUtils.round(amountInCents % centsRoundTo);

    if (restCents == 0) {
      return;
    }

    this.noRndSum = this.total;
    if (restCents > 4) {
      // round top
      const _rndSum = (centsRoundTo - restCents) / 100;
      this.rndSum = _rndSum * -1;
      this.total += _rndSum;
    } else {
      // round down
      this.rndSum = restCents / 100;
      this.total -= this.rndSum;
    }
  }

  private _addProductTax(product: IReceiptProduct) {
    let _exciseAmount = 0;
    // excise
    (<any>product).letters = '';
    if (product.excisetaxid > 0 && product.excisetaxpercent > 0) {
      const _turnover = product.amount;
      const _sourceSum = product.totalAmount;

      _exciseAmount = MoneyUtils.round(
        (_sourceSum / (100 + product.excisetaxpercent)) *
          product.excisetaxpercent,
      );

      this._addTax(
        product.excisetaxletter,
        1,
        product.excisetaxpercent,
        product.excisetaxname,
        _exciseAmount,
        _sourceSum,
        _turnover,
      );

      (<any>product).exciseTaxAmount = _exciseAmount;
      (<any>product).letters = product.excisetaxletter;
    }

    if (product.producttaxid > 0 && product.producttaxpercent > 0) {
      const _turnover = product.amount;
      const _sourceSum = MoneyUtils.round(product.totalAmount - _exciseAmount);
      let _taxAmount = MoneyUtils.round(
        (_sourceSum / (product.producttaxpercent + 100)) *
          product.producttaxpercent,
      );

      this._addTax(
        product.producttaxletter,
        0,
        product.producttaxpercent,
        product.producttaxname,
        _taxAmount,
        _sourceSum,
        _turnover,
      );

      (<any>product).productTaxAmount = _taxAmount;

      if ((<any>product).letters) {
        (<any>product).letters += product.producttaxletter;
      } else {
        (<any>product).letters = product.producttaxletter;
      }
    } else if (product.producttaxid > 0) {
      const taxLetter = product.producttaxletter;
      const taxName = product.producttaxname;
      const _turnover = product.amount;
      const _sourceSum = MoneyUtils.round(product.totalAmount - _exciseAmount);

      this._addTax(taxLetter, 0, null, taxName, 0, _sourceSum, _turnover);

      (<any>product).productTaxAmount = 0;

      if ((<any>product).letters) {
        (<any>product).letters += taxLetter;
      } else {
        (<any>product).letters = taxLetter;
      }
    } else if (this.useDefaultTax) {
      const defultTaxLetter = this.defaultTaxLetter;
      const _turnover = product.amount;
      const _sourceSum = MoneyUtils.round(product.totalAmount - _exciseAmount);

      this._addTax(
        defultTaxLetter,
        0,
        null,
        'БЕЗ ПДВ',
        0,
        _sourceSum,
        _turnover,
      );

      (<any>product).productTaxAmount = 0;

      if ((<any>product).letters) {
        (<any>product).letters += defultTaxLetter;
      } else {
        (<any>product).letters = defultTaxLetter;
      }
    }
  }

  private _addTax(
    letter: string,
    taxType: number,
    percent: number | null,
    name: string,
    sum: number,
    sourcesum: number,
    turnover: number,
  ) {
    if (this.taxes == null) {
      this.taxes = [];
    }

    let _tax = this.taxes.find(
      (t) => letter && t.LETTER.toLowerCase() == letter.toLowerCase(),
    );

    if (_tax) {
      _tax.SUM += sum;

      if (turnover > 0) {
        _tax.TURNOVER += turnover;
      }

      if (sourcesum > 0) {
        _tax.SOURCESUM += sourcesum;
      }
    } else {
      _tax = {
        TYPE: taxType,
        NAME: name,
        LETTER: letter,
        PRC: percent,
        TURNOVER: turnover,
        SOURCESUM: sourcesum,
        SUM: sum,
      };

      this.taxes.push(_tax);
    }
  }

  // private getSum(total: number, product: IReceiptProduct) {
  //   if (product.productTypeId == 1 && product.unitId == 1) {
  //     product.amount = (product.price * product.quantity) / 1000;
  //   } else if (
  //     product.weighted ||
  //     ((product.productTypeId == 3 || product.productTypeId == 6) &&
  //       product.unitId == 1)
  //   ) {
  //     product.amount = (product.price * product.quantity) / 100;
  //   } else {
  //     product.amount = product.price * product.quantity;
  //   }

  //   return parseFloat((total + product.amount).toFixed(2));
  // }

  // private _calculateChips(total: number, product: IReceiptProduct) {
  //   const chipsCost =
  //     (product.chips_cost - (product.chips_for_issue || 0)) * product.quantity;

  //   if (!chipsCost) {
  //     return parseFloat((total + 0).toFixed(2));
  //   }
  //   return parseFloat((total + chipsCost).toFixed(2));
  // }
}

export interface ICategory {
  id?: number;
  name?: string;
  parentid?: number;
  stockid?: number;
  workareaid?: number;
  imageurl?: string;
  selected?: boolean;
  stock?: string;
  parent_category_id?: number;

  products?: any[];
  children?: ICategory[];
}

export interface IProduct {
  id: number;
  name: string;
  ingredients_group_name: string;
  cost: number;
  markup: string;
  isingredient: boolean;
  unitid: number;
  unit: string;
  unitdisabled?: boolean;
  categoryid?: number;
  work_area_id?: number;
  categoryname?: string;
  price: number;
  netprice: string;
  deleted: Date;
  disabled: boolean;
  producttypeid?: number;
  product_type_id?: number;
  stockid?: number;
  stock?: string;
  weighted?: boolean;
  logoImage?: string;
  logoName?: string;
  imageurl?: string;
  order?: number;
  barcode?: string;
  chipid?: number;
  chipscost?: number;
  usechips?: boolean;
  chipsforissue?: number;
  chips_cost?: number;
  chips_for_issue?: number;

  ingredients: IIngredient[];
  groups: IIngredientsGroup[];
  subproducts?: IProduct[];

  producttaxid?: number;
  producttaxname?: string;
  producttaxpercent?: number | null;
  producttaxletter?: string;

  excisetaxid?: number;
  excisetaxname?: string;
  excisetaxpercent?: number;
  excisetaxletter?: string;
  uktzedcode?: string;
  excisemarkrequired?: boolean;

  taxprice?: number;
  coinsPrice: number;
  coinsBack: number;
  uom: { divisible: boolean; name: string };
  category_id?: number;
  systemCode?: string;

  addIngredient(): void;
  removeIngredient(index: number): void;
  selectIngredient(index: number, ingredient: IProduct): void;
  copyIngredients(product: IProduct): void;
}

export interface IIngredient {
  id: number;
  cost: number;
  total: number;
  quantity: number;
  productid: number;
  ingredient: IProduct;
}

export interface IIngredientsGroup {
  productId?: number;
  name: string;
  price: number;
  cost?: number;
  costOnly?: boolean;

  ingredients: any[];
}

export interface ICustomerRequestModel {
  Id: number;
  CompanyName: string;
  DiscountId: string;
  LoyaltyProgramId: string;
  LoyaltyTypeId: string;
  LoyaltyPlatformCode: string;
  CustomeCode: string;
  FirstName: string;
  LastName: string;
  Patronymic: string;
  ImageUrl: string;
  Phone: string;
  Birthday: string;
  GenderId: number;
  BonusesAccount: number;
  CoinsAccount: number;
  PercentDiscount: number;
  DiscountName: string;
  LoyaltyDiscount: number;
  LoyaltyName: string;
  Deleted: string;
  DeletedBy: string;
  IsLastRequested: boolean;
  LoyaltyPrograms: any[];
  Company: string;
}
